/**
 * The over-the-air manifest (`reference/api-contracts.md` §15, plan D45).
 *
 * CI writes it to the public R2 bucket at `ota/<env>/manifest.json`, and the
 * CDN serves it with `Cache-Control: no-cache`. There is no API route. The CI
 * step that writes it (T72) asserts its JSON against this schema, so this file
 * is the contract for both sides.
 */
import { z } from "zod";

export const otaManifest = z.object({
  version: z.string().min(1).max(64), // = VITE_BUNDLE_VERSION of the zipped build (git sha, 12 chars)
  url: z.url(), // https://cdn.mypocketgym.app/ota/<env>/<version>.zip (immutable)
  checksum: z.string().min(1), // from `capgo bundle encrypt`
  sessionKey: z.string().min(1), // from `capgo bundle encrypt`
  minNativeBuild: z.int().positive(), // android versionCode the bundle needs
  publishedAt: z.iso.datetime(),
});

export type OtaManifest = z.infer<typeof otaManifest>;

export type OtaEnv = "development" | "production";

const OTA_ORIGIN = "https://cdn.mypocketgym.app";

/**
 * Where the manifest for `env` lives. `env` is the build-time
 * `VITE_OTA_ENV` (T03), `development` unless the release build sets it.
 */
export function manifestUrl(env: OtaEnv): string {
  return `${OTA_ORIGIN}/ota/${env}/manifest.json`;
}
